<template>
	<Card>
		<div class="container-fluid">
			<div class="row pt-3 pb-5">
				<div class="col-sm-12">
					<h5 class="back-title" @click="back()">
						<i class="fa fa-angle-left"></i> Back To Admin
					</h5>
				</div>
				<div class="col-sm-12 d-flex justify-content-center" v-if="!!showCreate">
					<div class="form-group">
						<label for="name" class="text-white">Channel Type Name</label>
						<input id="name" type="text" class="channeltype-input d-block" v-model="editItem.type_name"/>
					</div>
					<div class="form-group">
						<label for="unit" class="text-white">Unit</label>
						<input id="unit" type="text" class="channeltype-input d-block" v-model="editItem.type_unit"/>
					</div>
					<div class="form-group">
						<label for="function" class="text-white">Function</label>
						<select id="function" class="create-select d-block" v-model="editItem.type_function">
							<option v-for="func in functions" :value="func.value">
								{{ func.label }}
							</option>
						</select>
					</div>
					<!-- <div class="form-group">
						<label for="resolution" class="text-white">Resolution</label>
						<input
							id="resolution"
							type="text"
							class="channeltype-input d-block"
							v-model="editItem.type_resolution"
						/>
					</div> -->
				<!-- 	<div class="form-group">
						<label for="display" class="text-white">Display</label>
						<select id="display" class="create-select d-block" v-model="editItem.type_line">
							<option v-for="dis in displays" :value="dis.value">
								{{ dis.label }}
							</option>
						</select>
					</div> -->
					<div class="form-group">
						<label for="multiplier" class="text-white">CO2 Multiplier</label>
						<input
							id="multiplier"
							type="text"
							class="channeltype-input d-block"
							v-model="editItem.type_multiplier"
						/>
					</div>
					<div class="form-group" style="padding-top: 27px">
						<button type="button" class="create-type" @click="createType()" v-if="isEdit">
							Update Type
						</button>
						<button type="button" class="create-type" @click="createType()" v-else>
							Create Type
						</button>
					</div>
				</div>
				<div class="col-sm-4 offset-sm-2">
					<div class="form-group mt-1 mb-1 justify-content-center" v-if="showError">
						<p class="error-message" v-for="message in messages">
							<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ message }}
						</p>
					</div>
				</div>
				<div class="col-sm-12" style="position: relative">
					<button
						class="add-button"
						@click="showCreateInput()"
						v-if="!showCreate"
					>
						Add New Channel Type
					</button>
					<v-client-table
						:columns="fields"
						:data="data"
						:options="options"
						class="text-center"
					>
						<template v-slot:actions="props">
							<button class="admin-action" @click="editChannelType(props.row)">
								<i class="fa fa-edit"></i>
								Edit
							</button>
							&nbsp;&nbsp;
							<button
								class="admin-action"
								@click="deleteChannelType(props.row)"
							>
								<i class="fa fa-remove"></i> Delete
							</button>
						</template>
					</v-client-table>
				</div>
			</div>
		</div>
	</Card>
</template>

<script>
import Card from "@/components/Cards/Card";
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

export default {
	name: "Channel-Types",
	components: {
		Card,
	},
	computed: {
		...mapGetters({
			periodTime: 'settime/getPeriodTime',
			user: 'auth/getUser'
		})
	},
	data() {
		return {
			showCreate: false,
		  editItem: null,
		  isEdit: false,
		  showError: false,
		  messages: [],
			functions: [
				{ label: "Average", value: "AVG" },
				{ label: "Maximum", value: "MAX" },
				{ label: "Sum", value: "SUM" },
			],
			displays: [
				{ label: "Spline", value: "spline" },
				{ label: "Line", value: "line" },
				{ label: "Column", value: "column" },
				{ label: "Scatter", value: "scatter" },
			],
			fields: [
				"type_name",
				"type_unit",
				"type_function",
				"type_multiplier",
				"actions",
			],
			data: [],
			options: {
				headings: {
					name: "Channel Type Name",
					unit: "unit",
					function: "Function",
					multiplier: "CO2 Multiplier",
					actions: "Actions",
				},
				sortable: ["type_id", "type_name"],
				texts: {
					filterPlaceholder: "Search...",
				},
				perPage: 10,
			},
		};
	},
	async created() {
		this.data = await this.getChannelTypes();
	},
	methods: {
		...mapActions({
			getChannelTypes: "admin/getChannelTypes",
			addChannelType: "admin/addChannelType"
		}),
		showCreateInput() {
			this.editItem = {
				type_name: '',
				type_unit: '',
				type_multiplier: null,
				type_function: null,
			};
			this.showCreate = true;
		},
		editChannelType(row) {
			this.isEdit = true;
			this.editItem = row;
			this.showCreate = true;
		},
		deleteChannelType(row) {
		},
		back() {
			this.$router.push({ name: "admin" });
		},
		async createType() {
			this.messages = [];
			if (!this.editItem.type_name) {
				this.messages.push('Name is required');
			}

			if (!this.editItem.type_unit) {
				this.messages.push('Unit is required');
			}

			if (!this.editItem.type_multiplier) {
				this.messages.push('CO2 multiplier is required');
			}

			if (!this.editItem.type_function) {
				this.messages.push('Function is required');
			}
			
			if (this.messages.length === 0) {
				this.showError = false;
			} else {
				this.showError = true;
			}

			if (!this.showError) {
				await this.addChannelType(this.editItem);
				let message = '';

				if (this.isEdit) {
					message = 'Channel Type is updated successfully';
				} else {
					message = 'Channel Type is created successfully';
				}
				this.$toasted.show(message, {
					type: "success",
					duration: 2500,
				});
			}
			this.isEdit = false;
			this.showCreate = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.error-message {
	color: #a95434;
	font-family: "Nunito Sans Light";
}
.channeltype-input {
	width: 10vw;
	height: 35px;
	border: 1px solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-radius: 0;
	z-index: 8;
	font-size: 14px;
	font-family: "Nunito Sans Light";
}
.back-title {
	color: #4fcf8d;
	cursor: pointer;

	&:hover {
		color: #4fcf00;
		opacity: 0.8;
	}
}
.admin-select {
	height: 25px;
	background-color: #1e365d;
	color: #ffffff;
	opacity: 0.9;
	border-color: #fdfdfd;
	border-radius: 4px;
}

.create-type {
	width: 12vw;
	height: 35px;
	border: 1px solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-radius: 0px;
	z-index: 8;
	font-size: 14px;
	font-family: "Nunito Sans Light";
	&:hover {
		background-color: #1f5881;
	}
}
.create-select {
	width: 10vw;
	height: 35px;
	background-color: #1e365d;
	color: #ffffff;
	opacity: 0.9;
	border-color: #fdfdfd;
	border-radius: 0px;
}
.admin-action {
	height: 30px;
	border: 1px solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-radius: 4px;
	z-index: 8;
	font-size: 14px;
	font-family: "Nunito Sans Light";
	&:hover {
		background-color: #1f5881;
	}
}
</style>
